<!-- <button
  [type]="type"
  class="common-btn"
  [ngClass]="['btn form-control', btnClassName]"
  (click)="onClick()"
  [ngStyle]="{ 
    'background-color': buttonColor, 
    'border-color': borderColor,
    'color': textColor,
    'border-radius': borderRadius,
     }"
  [disabled]="disable"
>
<i [ngClass]="iconName" *ngIf="iconName && iconFrontOrBack == 'F'"></i>
  {{ buttonText }}
<i [ngClass]="iconName" *ngIf="iconName && iconFrontOrBack == 'B'"></i>
</button> -->

<button
  [type]="type"
  class="common-btn"
  [ngClass]="['btn form-control', btnClassName , btnStyleType]"
  (click)="onClick()"
  [ngStyle]="{ 
    'background-color': buttonColor, 
    'border-color': borderColor,
    'color': textColor,
    'border-radius': borderRadius
  }"
  [disabled]="disable || loading"
>
  <!-- Front Icon or Spinner -->
  <!-- <ng-container *ngIf="loading; else iconTemplate">
    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
    Loading...
  </ng-container>
  <ng-template #iconTemplate>
    <i [ngClass]="iconName" *ngIf="iconName && iconFrontOrBack == 'F'"></i>
    {{ buttonText }}
    <i [ngClass]="iconName" *ngIf="iconName && iconFrontOrBack == 'B'"></i>
  </ng-template> -->
  <i [ngClass]="iconName"></i>
  {{ buttonText }}
</button>
